import { EnvironmentType } from './type';
import packageJson from '../../package.json';

// TODO replace with your own Supabase URL and key
export const environment: EnvironmentType = {
  production: true,
  supabaseUrl: 'https://nomkaqlbmtkqotegezxe.supabase.co',
  supabaseKey: 'sb_publishable_wE6NSrUFv1YLYbnJC6s9PA_6daA0EFZ',
  appUrl: 'https://heybible.app',
  bugsplat: {
    database: packageJson.database,
    application: packageJson.name,
    version: packageJson.version,
  },
} as EnvironmentType;
